module.exports = __webpack_public_path__ + "static/media/myphoto2.41a7df21.jpg";